export default __webpack_public_path__ + "static/media/redux.cda003d4.svg";